module.exports = __webpack_public_path__ + "img/沙苑蒺藜.9aba23c0.jpg";